import { type TextFetcher } from './index';
import { createContext, useContext } from 'react';
import { type CountryLocalizations, Locale } from './types';

export interface LanguageContextProps {
  locale: Locale;
  getLocalizedText: TextFetcher;
  countryLocalization: CountryLocalizations;
  setLocale: (locale: Locale) => void;
}

export const LanguageContext = createContext<LanguageContextProps | null>(null);

export const useLanguageContext = (): LanguageContextProps => {
  const languageContext = useContext(LanguageContext);
  if (languageContext === null) {
    throw new Error('LanguageContext not initialized');
  }
  return languageContext;
};
